var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['table-container', _vm.className]},[(_vm.title)?_c('h3',{staticClass:"table-title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('div',{staticClass:"table-shadow"},[_c('v-simple-table',{style:({ minWidth: _vm.minWidth ?? 0 })},[_vm._t("default")],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }